import { create } from 'zustand';
import { DateTime } from 'luxon';

type DashboardStore = {
  startDate: Date;
  endDate: Date;
  type: 'daily' | 'weekly' | 'monthly';
  schoolsIds?: string[];
  schools: string[];
  totalUsers: number;
  totalActiveUsers: number;
  setValues: (values: Partial<DashboardStore>) => void;
  getDateRange: () => { startDate: string; endDate: string } | undefined;
  updateTotalUsers: (totalUsers: number) => void;
  updateTotalActiveUsers: (totalActiveUsers: number) => void;
  getPeriod: () => 'DAY' | 'WEEK' | 'MONTH';
};

export const useDashboardStore = create<DashboardStore>()((set, get) => {
  const now = DateTime.now();
  const startDate = now.startOf('month');
  const endDate = now.endOf('month');

  return {
    startDate: startDate.toJSDate(),
    endDate: endDate.toJSDate(),
    type: 'daily',
    schoolsIds: undefined,
    schools: [],
    totalActiveUsers: 0,
    totalUsers: 0,
    getPeriod: () => {
      const { type } = get();

      if (type === 'daily') {
        return 'DAY';
      }

      if (type === 'weekly') {
        return 'WEEK';
      }

      if (type === 'monthly') {
        return 'MONTH';
      }

      return 'DAY';
    },
    updateTotalUsers: (totalUsers: number) => set({ totalUsers }),
    updateTotalActiveUsers: (totalActiveUsers: number) => set({ totalActiveUsers }),
    setValues: (values: Partial<DashboardStore>) => set(values),
    getDateRange: () => {
      const { startDate, endDate } = get();
      if (!startDate || !endDate) return;
      if (startDate.toString() === 'Invalid Date' || endDate.toString() === 'Invalid Date') return;
      return {
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
      };
    },
  };
});
